export default class UpdateDto {
  public itemId?: number;

  public action: "add" | "remove" | "change";
}
